// Internal deps
import { userRoles } from '../security/userRoles';
import useUserTrazability from './useUserTrazability';
/** @typedef {userRoles[keyof userRoles]} UserRoles */

/**
 * @typedef Link
 * @property {"administracion" | "certificaciones" | "servicios" | null} app
 * @property {Function} callback
 * @property {number} id
 * @property {string} name
 * @property {string} pathname
 * @property {UserRoles[]} permissions
 * @property {string} url
 */

/**
 * @typedef YClickLink
 * @property {number} id
 * @property {string} title
 * @property {Link[]} links
 */

const useHomeUtils = () => {
  const { handleShowTrazabilityModal } = useUserTrazability();
  const getYClickLinks = () => {
    /** @type {YClickLink[]} */
    return [
      {
        id: 1,
        title: 'Solicitudes de Servicio',
        links: [
          {
            app: 'servicios',
            callback: () => { },
            id: 12,
            name: 'Crear nueva Solicitud',
            pathname: '/createMultiple',
            permissions: [userRoles.SOLICITANTE],
            url: '',
          },
          {
            app: 'servicios',
            callback: () => { },
            id: 11,
            name: 'Consultar Bandeja de Solicitud de Servicio',
            pathname: '',
            permissions: [
              userRoles.INSPECTOR,
              userRoles.PROVEEDOR_ADMINISTRADOR,
              userRoles.PROVEEDOR_NOTIFICADOR,
              userRoles.USUARIO_CONSULTAS,
              userRoles.SOLICITANTE,
              userRoles.SUPERVISOR_NOTIFICADOR_YPF,
              userRoles.RESPONSABLE_PEP_PROYECTO,
              userRoles.GERENTE_COMPRA,
            ],
            url: '',
          },
          {
            app: 'servicios',
            callback: () => { },
            id: 15,
            name: 'Administrar modelos de Solicitudes',
            pathname: '/manage-temp/workReport',
            permissions: [
              userRoles.PROVEEDOR_NOTIFICADOR,
              userRoles.SUPERVISOR_NOTIFICADOR_YPF,
            ],
            url: '',
          },
          {
            app: 'servicios',
            callback: () => { },
            id: 16,
            name: 'Administrar modelos de Solicitudes',
            pathname: '/manage-temp/request',
            permissions: [userRoles.SOLICITANTE],
            url: '',
          },
          {
            app: 'servicios',
            callback: () => { },
            id: 13,
            name: 'Notificar Parte de Trabajo s/ Solicitud',
            pathname: '/create-asds',
            permissions: [
              userRoles.PROVEEDOR_NOTIFICADOR,
              userRoles.SUPERVISOR_NOTIFICADOR_YPF,
            ],
            url: '',
          },
          {
            app: 'servicios',
            callback: () => { },
            id: 14,
            name: 'Supervisar Partes de Trabajo',
            pathname: '/approver',
            permissions: [userRoles.APROBADOR],
            url: '',
          },
        ],
      },
      {
        id: 2,
        title: 'Inspección y certificación',
        links: [
          {
            app: 'certificaciones',
            callback: () => { },
            id: 21,
            name: 'Gestionar Autorizaciones',
            pathname: '/#/inspeccion/resumen',
            permissions: [userRoles.INSPECTOR],
            url: '',
          },
          {
            app: 'certificaciones',
            callback: () => { },
            id: 22,
            name: 'Consultar Bandeja de Errores de Certificación',
            pathname: '/#/errores/partes',
            permissions: [
              userRoles.CONTROL_ERRORES_SAP,
              userRoles.RESPONSABLE_PEP_PROYECTO,
              userRoles.GERENTE_COMPRA,
              userRoles.USUARIO_CONSULTAS
            ],
            url: '',
          },
          {
            app: 'certificaciones',
            callback: () => { },
            id: 23,
            name: 'Consultar Bandeja de Habilitas',
            pathname: '/#/habilitas',
            permissions: [
              userRoles.INSPECTOR,
              userRoles.PROVEEDOR_ADMINISTRADOR,
              userRoles.USUARIO_CONSULTAS
            ],
            url: '',
          },
        ],
      },
      {
        id: 3,
        title: 'Reportes',
        links: [
          {
            app: 'certificaciones',
            callback: () => { },
            id: 31,
            name: 'Generar Reporte de Trazabilidad',
            pathname: '/#/reporte-certificacion',
            permissions: [
              userRoles.ADMINISTRADOR_CONTRATO,
              userRoles.ADMINISTRADOR_GENERAL_CONTRATOS,
              userRoles.INSPECTOR,
              userRoles.REFERENTE_CONTROL_GESTION,
              userRoles.CONTROL_ERRORES_SAP,
              userRoles.PROVEEDOR_ADMINISTRADOR,
              userRoles.PROVEEDOR_NOTIFICADOR,
              userRoles.USUARIO_CONSULTAS,
              userRoles.SOLICITANTE,
              userRoles.SUPERVISOR_NOTIFICADOR_YPF,
              userRoles.APROBADOR,
              userRoles.REFERENTE_COMPRAS,
              userRoles.RESPONSABLE_PEP_PROYECTO,
              userRoles.GERENTE_COMPRA,
            ],
            url: '',
          },
          {
            app: '',
            callback: () => { },
            id: 32,
            name: 'Descargar Informe de Trazabilidad de Usuarios',
            pathname: '',
            permissions: [userRoles.AUDITOR_SEGURIDAD],
            url: '',
            isDownload: true,
            actionDownload: () => handleShowTrazabilityModal(true),
          },
          {
            app: 'servicios',
            callback: () => { },
            id: 33,
            name: 'Generar Reporte de Provisión',
            pathname: '/reporte-provision',
            permissions: [
              userRoles.INSPECTOR,
              userRoles.REFERENTE_CONTROL_GESTION,
            ],
            url: '',
          },
        ],
      },
      {
        id: 4,
        title: 'Administración',
        links: [
          {
            app: 'certificaciones',
            callback: () => { },
            id: 41,
            name: 'Configurar Contratos',
            pathname: '/#/contratos',
            permissions: [
              userRoles.ADMINISTRADOR_CONTRATO,
              userRoles.ADMINISTRADOR_GENERAL_CONTRATOS,
              userRoles.INSPECTOR,
            ],
            url: '',
          },
          {
            app: 'certificaciones',
            callback: () => { },
            id: 42,
            name: 'Configurar Cuenta Contable',
            pathname: '/#/cuenta-contable',
            permissions: [userRoles.REFERENTE_CONTROL_GESTION, userRoles.USUARIO_CONSULTAS],
            url: '',
          },
          {
            app: 'certificaciones',
            callback: () => { },
            id: 43,
            name: 'Clasificar Órdenes Internas',
            pathname: '/#/ordenes-internas',
            permissions: [userRoles.REFERENTE_CONTROL_GESTION, userRoles.USUARIO_CONSULTAS],
            url: '',
          },
          {
            app: 'administracion',
            callback: () => { },
            id: 53,
            name: 'Administrar Servicios',
            pathname: '/#/service-table',
            permissions: [userRoles.ADMINISTRADOR_USUARIO_PROPIEDADES],
            url: '',
          },
          {
            app: 'administracion',
            callback: () => { },
            id: 54,
            name: 'Administrar Proveedores',
            pathname: '/#/provider-table',
            permissions: [userRoles.ADMINISTRADOR_USUARIO_PROPIEDADES],
            url: '',
          },
          {
            app: 'administracion',
            callback: () => { },
            id: 55,
            name: 'Administrar Unidades de Negocio',
            pathname: '/#/business-unit-table',
            permissions: [userRoles.ADMINISTRADOR_USUARIO_PROPIEDADES],
            url: '',
          },
          {
            app: 'administracion',
            callback: () => { },
            id: 81,
            name: 'Administrar Objeto de Imputación - Responsable PEP Proyecto',
            pathname: '/#/imputation-object-table',
            permissions: [userRoles.ADMINISTRADOR_USUARIO_PROPIEDADES],
            url: '',
          },
          {
            app: 'administracion',
            callback: () => { },
            id: 82,
            name: 'Administrar CECO - Centro Logístico',
            pathname: '/#/ceco-table',
            permissions: [userRoles.ADMINISTRADOR_USUARIO_PROPIEDADES],
            url: '',
          },
          {
            app: 'administracion',
            callback: () => { },
            id: 83,
            name: 'Administrar CECO - Tipo de CECO',
            pathname: '/#/ceco-type-table',
            permissions: [userRoles.ADMINISTRADOR_USUARIO_PROPIEDADES],
            url: '',
          },
          {
            app: 'administracion',
            callback: () => { },
            id: 84,
            name: 'Administrar Eventos',
            pathname: '/#/events-table',
            permissions: [userRoles.ADMINISTRADOR_USUARIO_PROPIEDADES],
            url: '',
          },
          {
            app: 'administracion',
            callback: () => { },
            id: 85,
            name: 'Administrar Objeto de Imputación - Ubicaciones Genéricas ',
            pathname: '/#/imputation-object-generic-location-table',
            permissions: [userRoles.ADMINISTRADOR_USUARIO_PROPIEDADES],
            url: '',
          },
          // {
          //   id: 43,
          //   url: "#",
          //   callback: () => {},
          //   name: "Alta relación cuenta contable",
          //   permissions: [userRoles.REFERENTE_CONTROL_GESTION],
          // },
        ],
      },
      {
        id: 5,
        title: 'Roles y Usuarios',
        links: [
          {
            app: 'administracion',
            callback: () => { },
            id: 44,
            name: 'Consultar Bandeja de Usuarios',
            pathname: '/#/external-user-table',
            permissions: [userRoles.ADMINISTRADOR_USUARIO_EXTERNO],
            url: '',
          },
          {
            app: 'administracion',
            callback: () => { },
            id: 43,
            name: 'Consultar Bandeja de Usuarios',
            pathname: '/#/internal-user-table',
            permissions: [
              userRoles.ADMINISTRADOR_USUARIO_SEGURIDAD,
              userRoles.ADMINISTRADOR_USUARIO_PROPIEDADES,
              userRoles.AUDITOR_SEGURIDAD,
            ],
            url: '',
          },
          {
            app: 'administracion',
            callback: () => { },
            id: 52,
            name: 'Consultar Roles',
            pathname: '/#/roles-table',
            permissions: [userRoles.ADMINISTRADOR_USUARIO_PROPIEDADES],
            url: '',
          },
          {
            app: 'administracion',
            callback: () => { },
            id: 51,
            name: 'Administrar Grupo',
            pathname: '/#/group-table',
            permissions: [userRoles.ADMINISTRADOR_USUARIO_PROPIEDADES],
            url: '',
          },
        ],
      },
      //NOSONAR: Uncomment when they become required; currently hidden
      // {
      //   id: 6,
      //   title: "Tablas SAP MM",
      //   links: [
      //     {
      //       app: null,
      //       callback: () => {},
      //       id: 61,
      //       name: "Contratos cabecera",
      //       pathname: "",
      //       permissions: [userRoles.ADMINISTRADOR_USUARIO_PROPIEDADES],
      //       url: "",
      //     },
      //     {
      //       app: null,
      //       callback: () => {},
      //       id: 62,
      //       name: "Contratos itemizados",
      //       pathname: "",
      //       permissions: [userRoles.ADMINISTRADOR_USUARIO_PROPIEDADES],
      //       url: "",
      //     },
      //     {
      //       app: null,
      //       callback: () => {},
      //       id: 63,
      //       name: "Contratos precio",
      //       pathname: "",
      //       permissions: [userRoles.ADMINISTRADOR_USUARIO_PROPIEDADES],
      //       url: "",
      //     },
      //   ],
      // },
      // {
      //   id: 7,
      //   title: "Tablas SAP PS",
      //   links: [
      //     {
      //       app: null,
      //       callback: () => {},
      //       id: 71,
      //       name: "Objeto de imputación PEP",
      //       pathname: "",
      //       permissions: [userRoles.ADMINISTRADOR_USUARIO_PROPIEDADES],
      //       url: "",
      //     },
      //     {
      //       app: null,
      //       callback: () => {},
      //       id: 72,
      //       name: "Objeto de imputación orden",
      //       pathname: "",
      //       permissions: [userRoles.ADMINISTRADOR_USUARIO_PROPIEDADES],
      //       url: "",
      //     },
      //     {
      //       app: null,
      //       callback: () => {},
      //       id: 73,
      //       name: "Objeto de imputación CECO",
      //       pathname: "",
      //       permissions: [userRoles.ADMINISTRADOR_USUARIO_PROPIEDADES],
      //       url: "",
      //     },
      //   ],
      // },
      // ,
      // {
      //   id: 9,
      //   title: "Tablas interface OW",
      //   links: [
      //     {
      //       app: null,
      //       callback: () => {},
      //       id: 91,
      //       name: "Equipo",
      //       pathname: "",
      //       permissions: [userRoles.ADMINISTRADOR_USUARIO_PROPIEDADES],
      //       url: "",
      //     },
      //     {
      //       app: null,
      //       callback: () => {},
      //       id: 92,
      //       name: "Locación",
      //       pathname: "",
      //       permissions: [userRoles.ADMINISTRADOR_USUARIO_PROPIEDADES],
      //       url: "",
      //     },
      //     {
      //       app: null,
      //       callback: () => {},
      //       id: 93,
      //       name: "Locación - Pozo",
      //       pathname: "",
      //       permissions: [userRoles.ADMINISTRADOR_USUARIO_PROPIEDADES],
      //       url: "",
      //     },
      //     {
      //       app: null,
      //       callback: () => {},
      //       id: 94,
      //       name: "Evento - Pozo",
      //       pathname: "",
      //       permissions: [userRoles.ADMINISTRADOR_USUARIO_PROPIEDADES],
      //       url: "",
      //     },
      //     {
      //       app: null,
      //       callback: () => {},
      //       id: 95,
      //       name: "Operación - Equipo",
      //       pathname: "",
      //       permissions: [userRoles.ADMINISTRADOR_USUARIO_PROPIEDADES],
      //       url: "",
      //     },
      //     {
      //       app: null,
      //       callback: () => {},
      //       id: 96,
      //       name: "Objeto de imputación - Evento - Pozo",
      //       pathname: "",
      //       permissions: [userRoles.ADMINISTRADOR_USUARIO_PROPIEDADES],
      //       url: "",
      //     },
      //   ],
      // },
    ];
  };
  /** @param {Link[]} linksArray @param {UserRoles[]} roles */
  const verifyLinkPermissions = (linksArray, roles) =>
    linksArray.filter((link) =>
      roles.some((role) => link.permissions.includes(role))
    );

  /**
   * @param {{id: number, nombre: UserRoles}[]} rolesArray
   * @param {import("../context/AppProvider").AppsURL} appsURL
   * @returns {YClickLink[]}
   */

  const getAllowedLinks = (appsURL, rolesArray = []) => {
    const roles = rolesArray.map((role) => role.nombre);

    const returnedLinks = [];
    const yClickLinksArray = getYClickLinks();

    yClickLinksArray.forEach((yClickLink) => {
      // se obtienen los links de cada sección, filtrados por roles/permisos
      const verifiedLinks = verifyLinkPermissions(yClickLink.links, roles);

      const links = verifiedLinks.map((link) => {
        const { pathname, app, ...restOfLink } = link;

        if (!app) return { ...restOfLink };

        return { ...restOfLink, url: `${appsURL[app]}${pathname}` };
      });

      // verify that there is at least one item inside the array
      // before pushing it into the array returned by the function
      if (links.length) {
        returnedLinks.push({
          id: yClickLink.id,
          title: yClickLink.title,
          links: links,
        });
      }
    });

    return returnedLinks;
  };
  return {
    getYClickLinks,
    getAllowedLinks,
  };
};

export default useHomeUtils;
